import React from 'lib/react';
import {
  EVGrid, makeStyles,
} from 'lib/components';
import Typography from 'commonComponents/typography';
import PropTypes from 'prop-types';
import { useSelector } from 'lib/redux';
import SkeletonLoader from 'commonComponents/skeletonLoader';

const useStyles = makeStyles(() => ({
  statContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '40%',
    '@media (min-width: 640px)': {
      flex: 1,
    },
  },
  statValue: {
    fontSize: '30px',
    lineHeight: '36px',
  },
  statLabel: {
    textTransform: 'uppercase',
  },
  statsSkeleton: {
    flex: 1,
    height: '100%',
  },
}));

function Stats(props) {
  const classes = useStyles();

  const reportAnalyticsLoading = useSelector(({ analyticsDashboard }) => analyticsDashboard.loading.reportAnalytics);

  if (reportAnalyticsLoading) return <SkeletonLoader className={classes.statsSkeleton} />;

  const { value, label } = props;

  return (
    <EVGrid className={classes.statContainer}>
      <Typography className={classes.statValue}>{value}</Typography>
      <Typography variant="label-600" fontColor="charcoal-600" className={classes.statLabel}>
        {label}
      </Typography>
    </EVGrid>
  );
}

Stats.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
};

export default Stats;
